module.exports = __webpack_public_path__ + "static/media/conta.1da589cc.svg";